import { takeLatest } from 'redux-saga'
import {
	call,
	select,
	put,
} from 'redux-saga/effects'

import callAny from '../helpers/call_any'
import formatError from '../helpers/error_formatter'
import actionTypes from 'redux/actions/actionTypes'
import {
	iVideoCreationOeqActions,
} from 'redux/actions/interactiveVideoCreation'
import { interactiveVideoSync, questionSync } from 'sync'
import activityTypes from 'helpers/enums/activityTypes'
import { identitySelector } from 'redux/selectors/interactive_video_creation'
import { oeqSave } from 'redux/sagas/creationTool/oeqSagas'
import { creationToolOeqSelector } from 'redux/selectors/creationTool'
import { saveInteractiveVideoActivity } from 'redux/sagas/interactive_video_creation_sagas'

function *createOeqActivity(action) {
	try {
		if (!action.activityUid) {
			// This code is only executed when it's a new activity
			// When is not all this data will be already given in
			// the url

			const interactiveVideoIdentityData = yield select(identitySelector)

			const newActivity = yield callAny(
				questionSync.create,
				interactiveVideoIdentityData.jwt,
			)

			const breakpointActivity = yield callAny(
				interactiveVideoSync.addBreakpointActivity,
				interactiveVideoIdentityData.uid,
				interactiveVideoIdentityData.jwt,
				action.breakpointUid,
				newActivity.payload.uid,
				activityTypes.OPEN_ENDED_QUESTION
			)

			yield put(
				iVideoCreationOeqActions.createNewOeqActivitySuccess(
					newActivity.payload.uid,
					breakpointActivity.uid,
				)
			)
		}
	} catch (error) {
		const formattedError = formatError(error)
		yield put(iVideoCreationOeqActions.createNewOeqActivityError(
			formattedError
		))
	}
}

function *saveOeqInteractiveVideoActivity() {
	yield call(oeqSave)

	const activityData = yield select(creationToolOeqSelector)
	const isEdition = yield call(saveInteractiveVideoActivity, activityData.activityUid)

	return isEdition
}

function *saveOeqActivity() {
	try {
		const isEdition = yield call(saveOeqInteractiveVideoActivity)

		yield put(
			iVideoCreationOeqActions.saveOEQSuccess(isEdition)
		)
	} catch (error) {
		const formattedError = formatError(error)
		yield put(iVideoCreationOeqActions.saveOEQError(formattedError))
	}
}

export default [
	takeLatest([
		actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_INITIALIZE,
		actionTypes.VIDEO_CREATION_OEQ_INITIALIZE,
		actionTypes.VIDEO_STANDALONE_OEQ_INITIALIZE,
	],
	createOeqActivity
	),
	takeLatest(
		actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE,
		saveOeqActivity
	),
]

export {
	createOeqActivity,
	saveOeqActivity,
}
